/**
 * Generic Authentication Types for Session Package
 * 
 * These types abstract away the specific authentication mechanism (TraineeCredentials)
 * so the session package can be used with different auth systems.
 */

/**
 * Generic auth credentials interface
 * Consumers can pass any credentials object that has isValid property
 */
export interface AuthCredentials {
  isValid: boolean;
  // Allow additional properties for flexibility
  [key: string]: any;
}

/**
 * Function type for creating auth headers
 * Consumers provide their own header creation logic
 */
export type CreateAuthHeaders = (credentials: AuthCredentials | null) => HeadersInit;

/**
 * Default header creator that returns minimal headers
 */
export const defaultCreateHeaders: CreateAuthHeaders = () => ({
  'Content-Type': 'application/json',
});
